import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row, Card, CardBody, ButtonToolbar, Button, Nav, NavItem, NavLink, TabContent, TabPane, CardTitle } from 'reactstrap';
import moment from 'moment';
import history from '../../../../history';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import reciptPdf from './ReciptPdf';
import ElectronicBillingHTTP from '../../../ElectronicBilling/api/ElectronicBillingHTTP';
import TalummHTTP from '../../../ElectronicBilling/api/TalummHTTP';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Spinner from 'react-bootstrap/Spinner';
import { InvoiceUtils } from '../../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/InvoiceUtils';
import ModalTemplatePdf from '../../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/ModalTemplatePDF';
import AlertModal from '../../../../shared/components/Modal';
import ReceiptsAdmisions from './ReceiptsAdmissions';
import FacturaTechHTTP from '../../../ElectronicBilling/api/FacturaTechHTTP';
import IconButton from '@material-ui/core/IconButton';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ModalUpdatePricesAdmision from './ModalUpdatePricesAdmision';
import Tooltip from '@material-ui/core/Tooltip';
import ReceiptAdmissionButtonUpdateFromPL from './ReceiptAdmissionButtonUpdateFromPL';
import { formatNumber } from '../../../Utils/Money';
import IFacturaAppHTTP from '../../../ElectronicBilling/api/IFacturaAppHTTP';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const renderField = ({
    input, disabled, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} disabled={disabled} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

let clinica = JSON.parse(sessionStorage.getItem('clinica'));

class ReceiptAdmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataPatient: null,
            dataAppointment: null,
            activities: [],
            typeDocument: '',
            documentNumber: this.props.location.state.dataPatient.num_documento,
            names: '',
            concept: '',
            paymentType: "",
            cash: "",
            card: "",
            check: "",
            total: 0,
            type: "",
            wayToPay: '',
            errors: {},
            urlLogo: "",
            profile: [],
            disabledFields: false,
            invoice: null,
            electronicInvoiceLoading: false,
            note: null,
            services: [],
            cufe: null,
            medicines: [],
            activeTab: "1",
            correo: '',
            cellphone: '',
            direccion: '',
            nombre_tercero: '',
            nit_tercero: '',
            telefono_tercero: '',
            direccion_tercero: null,
            correo_tercero: '',
            openModalPDF: false,
            colorAlertModal: 'success',
            messagAlerteModal: '',
            showAlertModal: false,
            userPermits: [],
            processInvalidCash: false,
            dataCreated: null,
            processCancel: false,
            isParticular: false,
            typeCard: '',
            transactionNumber: '',
            nameEntity: '',
            transactionOtherNumber: '',
            infoPrintRecipt: [],
            serviceUpdateData: null,
            openModalServiceUpdate: false,
            reloadListReceipts: false,
            setValueBy: 'VALOR',
            percentageValue: '', 
            validateConsulta: null
        }
    };

    componentDidMount() {
        //Validacion de Permisos
        var user = JSON.parse(sessionStorage.getItem('usuario'));
        if (user != null) {
            if (user.perfil != undefined) {
                var perfil = user.perfil.modulos;
                this.setState({ userPermits: perfil });
            } else {
                var perfil = [];
                this.setState({ userPermits: perfil });
            }
        } else {
            this.setState({ userPermits: [] });
        }

        this.setState({
            dataPatient: this.props.location.state.dataPatient,
            typeDocument: this.props.location.state.dataPatient.tip_documento,
            documentNumber: this.props.location.state.dataPatient.num_documento,
            correo: this.props.location.state.dataPatient.correo,
            cellphone: this.props.location.state.dataPatient.celular,
            direccion: this.props.location.state.dataPatient.direccion,
            nombre_tercero: this.props.location.state.dataPatient.nombre_tercero,
            nit_tercero: this.props.location.state.dataPatient.nit_tercero,
            telefono_tercero: this.props.location.state.dataPatient.telefono_tercero,
            direccion_tercero: this.props.location.state.dataPatient.direccion_tercero,
            correo_tercero: this.props.location.state.dataPatient.correo_tercero,
            note: this.props.location.state.dataPatient.invoiceNote
        }, () => {
            this.loadDataCita();
        });
        //Si el Recibo de Caja ya Existe traigalo
        if (this.props.location.state.dataCashReceipt != null) {
            this.loadCashReceipt(this.props.location.state.dataCashReceipt).then((res) => {
                this.getInvoice(this.props.location.state.dataCashReceipt.id_recibo);
            });
        }
        this.infoPrintReciept(parseInt(this.props.location.state.dataPatient.id_admision));
     
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        };
    };

    handlerCardType = (type) => {
        this.setState({ typeCard: type });
    }

    handlerNumberTransaction = (num) => {
        this.setState({ transactionNumber: num });
    }

    handlerNameEntity = (nameEntity) => {
        this.setState({ nameEntity: nameEntity });
    }

    handlerNumberOtherTransaction = (numb) => {
        this.setState({ transactionOtherNumber: numb });
    }

    validate = () => {

        var errors = this.state.errors;
        if (this.state.concept === '') {
            errors.concept = "Seleccione un concepto";
            //return true;
        } else {
            delete errors.concept;
        }

        if (this.state.card !== '' && this.state.wayToPay === '') {
            errors.wayToPay = "Seleccione una forma de pago de tarjeta";
        } else {
            delete errors.wayToPay;
        }

        if (this.state.paymentType === "" || this.state.paymentType == null || this.state.paymentType == undefined) {
            errors.paymentType = "Seleccione un medio de pago";
            //return true;
        }
        else {
            delete errors.paymentType;
        }

        if (this.state.paymentType === "Tarjeta") {
            if (this.state.typeCard === "" || this.state.typeCard == null || this.state.typeCard == undefined) {
                errors.cardType = "Seleccione un tipo de tarjeta";
            }
            else {
                delete errors.cardType;
            }
        }

        if (this.state.typeCard === "Debito" || this.state.typeCard === "Credito") {
            if (this.state.transactionNumber === "" || this.state.transactionNumber == null || this.state.transactionNumber == undefined) {
                errors.transactionNumber = "Digite el numero de transacción";
            }
            else {
                delete errors.transactionNumber;
            }
        }

        console.log(errors);
        this.setState({ errors: errors });
        if (Object.keys(errors).length === 0) {
            return false;
        } else {
            return true;
        }
    }

    //Recibo de Caja CON PAGOS
    createReceipt = () => {
        if (!this.validate()) {
            var paymentType = this.state.paymentType;

            var medio_pago = [];
            if (this.state.cash !== "" && !isNaN(this.state.cash)) {
                if (paymentType === "Tarjeta") {
                    medio_pago.push({ medio: paymentType, tipo_tarjeta: this.state.typeCard, nro_transaccion: this.state.transactionNumber, monto: parseInt(this.state.cash) })
                } else if (paymentType === "Otro") {
                    medio_pago.push({ medio: paymentType, entidad: this.state.nameEntity, nro_transaccion: this.state.transactionOtherNumber, monto: parseInt(this.state.cash) })
                } else {
                    medio_pago.push({ medio: paymentType, monto: parseInt(this.state.cash) })
                }
            }
            if (this.state.card !== "" && !isNaN(this.state.card)) {
                if (this.state.wayToPay.value === "DEBITO") {
                    medio_pago.push({ medio: "Debito", monto: parseInt(this.state.card) })
                } else if (this.state.wayToPay.value === "CREDITO") {
                    medio_pago.push({ medio: "Credito", monto: parseInt(this.state.card) })
                }
            }

            if (this.state.check !== "" && !isNaN(this.state.check)) {
                medio_pago.push({ medio: "Cheque", monto: parseInt(this.state.check) })
            }

            let usuario = sessionStorage.getItem('usuario') != undefined && sessionStorage.getItem('usuario') != null ? sessionStorage.getItem('usuario') : null;
            let id_usuario = usuario != null ? JSON.parse(usuario).id_usuario : null;

            var data = {
                id_historia: this.state.dataPatient.id_historia,
                id_admision: parseInt(this.state.dataPatient.id_admision),
                fecha_emision: moment(new Date()).format('YYYY/MM/DD HH:mm:ss'),
                forma_pago: paymentType,
                medio_pago: medio_pago,
                tipo_pago: this.state.concept,
                valor_paciente: parseInt(this.state.cash !== "" ? this.state.cash : "0") + parseInt(this.state.card !== "" ? this.state.card : "0") + parseInt(this.state.check !== "" ? this.state.check : "0"),
                moneda: "COP",
                servicios: this.state.services,
                id_tercero: this.state.type === "1" ? 1 : this.state.dataAppointment.idCliente,
                id_plan: this.state.dataAppointment.idPlan,
                tipo: parseInt(this.state.type), /* type: 1-Particular,2-Subsidiado,3-Contributivo,4-Regimen Especial,5-Contributivo Complementario,6-SOAT*/
                id_usuario: id_usuario,
                medicamentos: this.state.medicines,
                valido: true
            };
            //console.log("reciboscaja/create", data);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(res => {
                    this.setState({ dataCreated: res }, () => {
                        this.setState({ showAlertModal: true, colorAlertModal: 'success', messagAlerteModal: 'Recibo de Caja creado exitosamente' });
                    });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    finishCreateCashReceipt = (res) => {
        if (window.location.pathname === process.env.PUBLIC_URL + '/assitencial/receipt-admission') {
            history.replace(process.env.PUBLIC_URL + "/");
            setTimeout(() => {
                history.replace({
                    pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                    state: {
                        dataPatient: this.props.location.state.dataPatient,
                        dataCashReceipt: res.recibo_caja.reciboCaja,
                        dataPlan: res.recibo_caja.plan,
                        dataProfile: res.recibo_caja.clinica,
                        state: this.props.location.state.state
                    }
                });
            }, 0);
        } else {
            history.push({
                pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                state: {
                    dataPatient: this.props.location.state.dataPatient,
                    dataCashReceipt: res.recibo_caja.reciboCaja,
                    dataPlan: this.props.location.state.plan,
                    dataProfile: this.props.location.state.dataProfile,
                    state: this.props.location.state.state //////
                }
            });
        }
    }

    //Recibo de Caja SIN PAGOS
    createInvalidReceipt = () => {
        var medio_pago = [];
        medio_pago.push({ medio: "Efectivo", monto: 0 })
        let usuario = sessionStorage.getItem('usuario') != undefined && sessionStorage.getItem('usuario') != null ? sessionStorage.getItem('usuario') : null;
        let id_usuario = usuario != null ? JSON.parse(usuario).id_usuario : null;

        var data = {
            id_historia: this.state.dataPatient.id_historia,
            id_admision: parseInt(this.state.dataPatient.id_admision),
            fecha_emision: moment(new Date()).format('YYYY/MM/DD HH:mm:ss'),
            forma_pago: "Efectivo",
            medio_pago: medio_pago,
            tipo_pago: "COPAGO",
            valor_paciente: parseInt(this.state.cash !== "" ? this.state.cash : "0") + parseInt(this.state.card !== "" ? this.state.card : "0") + parseInt(this.state.check !== "" ? this.state.check : "0"),
            moneda: "COP",
            servicios: this.state.services,
            id_tercero: this.state.type === "1" ? 1 : this.state.dataAppointment.idCliente,
            id_plan: this.state.dataAppointment.idPlan,
            tipo: parseInt(this.state.type),
            id_usuario: id_usuario,
            medicamentos: this.state.medicines,
            valido: false
        };

        fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(res => {
                this.setState({ dataCreated: res }, () => {
                    this.setState({ showAlertModal: true, colorAlertModal: 'success', messagAlerteModal: 'Recibo de Caja creado exitosamente' });
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    generateInvoice = async () => {
        try {
            let usuarioFacturador = JSON.parse(sessionStorage.getItem('usuario'));
            this.setState({ electronicInvoiceLoading: true });
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/generar-factura', { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    id_recibo: this.props.location.state.dataCashReceipt.id_recibo,
                    nota: this.state.note,
                    id_usuario: usuarioFacturador.id_usuario
                })
            }).then(response => {
                return response.json();
            }).then(res => {
                let consecutivo = res.recibo_caja?.factura?.factTercero?.num_fac_ter;
                let id_factura = res.recibo_caja?.factura?.factTercero?.id_factura_t;
                let factura = res.recibo_caja?.factura.factTercero;
                this.alertModal('success', "Factura Creada Correctamente");
                this.setState({ invoice: factura, electronicInvoiceLoading: false });
            }).catch((error) => {
                this.setState({ electronicInvoiceLoading: false });
                console.error('Error:', error);
                this.alertModal('danger', "Ha ocurrido un error facturando");
            });
        }
        catch (error) {
            this.setState({ electronicInvoiceLoading: true });
            this.alertModal('danger', "Ha ocurrido un error facturando");
        }
    }

    againAtttemptElectronicInvoice = async (recibo_caja, id_factura, consecutivo) => {
        this.generateElectronicInvoice(recibo_caja, id_factura, consecutivo, true).then(() => {
            this.alertModal('success', "Factura Emitida Correctamente");
            this.setState({ electronicInvoiceLoading: false });
        }).catch(err => {
            this.alertModal('danger', "Fallo la emisión de Factura Electronica, por favor intente nuevamente")
            this.setState({ electronicInvoiceLoading: false });
            console.log(err);
        });
    }

    generateElectronicInvoice = async (recibo_caja, id_factura, consecutivo, charge) => {

        if (charge == true) {
            this.setState({ electronicInvoiceLoading: true });
        }

        let providerElectronicInvoice = await ElectronicBillingHTTP.getActualProvider();
        return new Promise(async (resolve, reject) => {
            switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
                case 1: //----------------Facturatech--------------------------

                    let num_fac_ter = null;
                    let id_factura_t = null;

                    if (this.state.invoice != null) {
                        if (this.state.invoice.num_fac_ter != null && this.state.invoice.num_fac_ter !== undefined) {
                            num_fac_ter = this.state.invoice.num_fac_ter;
                            id_factura_t = this.state.invoice.id_factura_t;
                        }
                    }

                    let InvoiceUt = new InvoiceUtils();
                    var idsReceipts = [this.props.location.state.dataCashReceipt.id_recibo];
                    await InvoiceUt.getReceiptsById(idsReceipts, this.props.location.state.dataCashReceipt.id_tercero, num_fac_ter).then((res) => {
                        if (res != null) {
                            FacturaTechHTTP.generateXMLInvoice(res.factura, "SALUD", id_factura_t, "INVOICE").then((success) => {
                                if (success == true) {
                                    FacturaTechHTTP.getCufeConfirmado(id_factura_t).then((cufe) => {
                                        this.setState({
                                            electronicInvoiceLoading: false,
                                            cufe: cufe != null && cufe != undefined ? cufe : null
                                        });
                                        resolve(cufe);
                                    }).catch((error) => {
                                        reject(error)
                                        throw new Error("Error obteniendo el CUFE");
                                    })
                                }
                                else {
                                    throw new Error("Error transmitiendo la Factura");
                                }
                            }).catch((error) => {
                                console.log(error);
                                reject(error)
                                throw new Error("Error transmitiendo la Factura");
                            });
                        }
                        else {
                            throw new Error("Ha ocurrido en la Factura");
                        }
                    }).catch((error) => {
                        console.log(error);
                        throw new Error("Error transmitiendo la Factura");
                    });

                    break;
                case 2: //----------------Talumm--------------------------
                    await TalummHTTP.importInvoice(id_factura).then(response_invoice => {
                        if (response_invoice != null) {
                            if (response_invoice.code == '200' || response_invoice.code == '00' || response_invoice.code == '203' || response_invoice.code == '201') {
                                this.setState({ cufe: response_invoice.cufe != null && response_invoice.cufe != undefined ? response_invoice.cufe : null });
                                resolve(response_invoice.cufe);
                            }
                            else {
                                reject(error)
                                throw new Error("Error de Validaciones en la Factura");
                            }
                            this.setState({ electronicInvoiceLoading: false });
                        }
                        else {
                            reject(error)
                            throw new Error("No se genero el JSON");
                        }
                    })
                    break;
                case 3: //--------------------------------iFacturaApp-------------------------------------------------- 
                    await IFacturaAppHTTP.importInvoiceiFacturaApp(id_factura).then(response_invoice => {
                        console.log("response_invoice", response_invoice)
                        if (response_invoice != null) {
                            if (response_invoice.statuCode == 200 || response_invoice.statuCode == 203) {
                                this.setState({ cufe: response_invoice.data.cufe != null && response_invoice.data.cufe != undefined ? response_invoice.data.cufe : null });
                                //alertModal('success', 'Facturacion Electronica Generada correctamente');
                                //setInvoiceElectronicProcess(false);
                                resolve(response_invoice.data.cufe);
                            }
                            else {
                                reject(error)
                                throw new Error("Error de Validaciones en la Factura");
                            }
                        }
                        else {
                            reject(error)
                            throw new Error("No se genero el JSON");
                        }
                    }).catch((error) => {
                        //setInvoiceElectronicProcess(false);
                        reject(error)
                        console.error('Error:', error);
                        //alertModal('danger', 'Ha ocurrido un error con la Facturación Electronica');
                    });
                    break;
            }
        })
    }

    documentStatus = (transaccionID) => {
        let dataSend = { transaccionID: transaccionID }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'factura-electronica/document-status-file', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            return response.json();
        }).then(res => {
            console.log(res);
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    getCufe = (consecutivo, id) => {

        let dataSend = { prefijo: consecutivo.split("-")[0], folio: consecutivo.split("-")[1] }

        fetch(process.env.REACT_APP_PUBLIC_URL + 'factura-electronica/get-cufe-file', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(res => {
                console.log(res);
                let cufe = res.return.resourceData.$value;
                this.saveCufe(id, cufe);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    saveCufe = (id, cufe) => {

        let dataSend = { id_factura_t: id, cufe: cufe }

        fetch(process.env.REACT_APP_PUBLIC_URL + 'factura-electronica/get-cufe-file', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(res => {
                console.log(res);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadDataCita = () => {

        var data = { id_cita: this.state.dataPatient.id_cita };
        //id_agenda: this.props.dataEvent.id_agenda 
        console.log(data);
        fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultarpaciente', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.existe) {
                    this.setState({ dataAppointment: data.contenido, services: data.contenido.servicios.servicios }, () => {
                        this.loadActivities().then((res_activities) => {
                            this.loadMedicines(data.contenido.servicios.servicios);
                        });
                    });                 
                    this.state.services.map((serData) => {
                        return this.setState({validateConsulta: serData.nombre.toUpperCase().includes("CONSULTA")}) 
                    })
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadMedicines = (services) => {
        let medicinesArr = [];
        for (let i = 0; i < services.length; i++) {
            if (services[i].medicamentos != undefined && services[i].medicamentos != null) {
                for (let j = 0; j < services[i].medicamentos.length; j++) {
                    //En los medicamentos guarda el Servicio que lo requiere para futuras gestiones con la Factura
                    services[i].medicamentos[j].id_servicio = services[i].id_servicio;
                    services[i].medicamentos[j].nombre_servicio = services[i].nombre;
                    services[i].medicamentos[j].costo_total = parseFloat(services[i].medicamentos[j].costo) * parseFloat(services[i].medicamentos[j].numero_unidades);
                    medicinesArr.push(services[i].medicamentos[j]);
                }
            }
        }

        this.setState({ medicines: medicinesArr }, () => {
            if (this.state.isParticular) {
                this.setState({ cash: this.calculateTotalCost(this.props.location.state.dataPatient.servicios, medicinesArr) });
            }
        });
    }

    loadActivities = async () => {

        var data = { id_tercero: this.state.dataAppointment.idCliente, id_plan: this.state.dataAppointment.idPlan };
        //console.log(data);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.existe) {
                console.log("SERTER/CONSULTAR", data)
                if ((data.contenido[0].tipo === 1 || data.contenido[0].tipo === 6) && this.props.location.state.dataCashReceipt == null && this.props.location.state.dataCashReceipt == undefined) {
                    this.setState({ cash: this.calculateTotalCost(this.props.location.state.dataPatient.servicios), isParticular: true })
                }
                this.setState({ type: data.contenido[0].tipo }, () => {
                    console.log("INFO_THIRD", this.state.type)
                    if (this.state.type == 1) {
                        this.setState({ concept: 'PARTICULAR' })
                    }
                    if (this.state.type == 6) {
                        this.setState({ concept: 'SOAT' })
                    }
                    if (this.state.type == 7) {
                        this.setState({ concept: 'POLIZA' })
                    }
                    if (this.state.type == 8) {
                        this.setState({ concept: 'PARTICULAR MEDICINA PREPAGADA' })
                    }
                    if (this.state.type == 9) {
                        this.setState({ concept: 'OTROS' })
                    }
                });
            }
            return data;
        }).catch((error) => {
            console.error('Error:', error);
            return null;
        });
    }

    loadDataProfile = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.length > 0) {
                    this.setState({
                        profile: data[0],
                        urlLogo: process.env.REACT_APP_PUBLIC_URL + "clinica/" + data[0].id_clinica + "/logo/" + sessionStorage.getItem('token')
                    })
                }
            })
            .catch((error) => {
                console.error('Error:', error);

            });
    }

    //Esteban Londoño Ospina 2/11/2021
    //Si el Recibo de Caja Existe Carguelo
    loadCashReceipt = async (cashReceipt) => {
        if (cashReceipt != null) {
            this.setState(
                {
                    paymentType: cashReceipt.forma_pago,
                    concept: cashReceipt.tipo_pago,
                    cash: Math.trunc(cashReceipt.total),
                    disabledFields: true
                },
            );
            if (cashReceipt.medio_pago.medio[0].medio === "Tarjeta") {
                this.setState({
                    typeCard: cashReceipt.medio_pago.medio[0].tipo_tarjeta,
                    transactionNumber: cashReceipt.medio_pago.medio[0].nro_transaccion
                })
            }
            if (cashReceipt.medio_pago.medio[0].medio === "Otro") {
                this.setState({
                    nameEntity: cashReceipt.medio_pago.medio[0].entidad,
                    transactionOtherNumber: cashReceipt.medio_pago.medio[0].nro_transaccion
                })
            }
        }
    }

    infoPrintReciept = async (id_admision) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(res => {
            this.setState({ infoPrintRecipt: res });
        }).catch((error) => {
            console.error('Error:', error);
            this.setState({ infoPrintRecipt: [] });
        });
    }

    showPDF = async () => {
        if (
            this.props.location.state.dataCashReceipt != null &&
            this.props.location.state.dataPlan != null &&
            this.props.location.state.dataProfile != null) {
            //console.log("RECIBOCAJA",this.props.location.state.dataCashReceipt);
            reciptPdf(this.props.location.state.dataCashReceipt, this.props.location.state.dataPlan, this.props.location.state.dataProfile, this.state.infoPrintRecipt);
        }
    }

    getInvoice = (id_recibo) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-por-recibo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_recibo: id_recibo })
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.factura != null) {
                this.setState({ invoice: data.factura, note: data.factura.nota != null ? data.factura.nota : "" });
            }
        }).catch((error) => {
            console.error('Error:', error);
            this.setState({ invoice: null });
        });
    }

    downloadPDFDIAN = async () => {
        let providerElectronicInvoice = await ElectronicBillingHTTP.getActualProvider();
        switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
            case 1: //Factura Tech
                await this.downloadPDF64Ftech(this.state.invoice.num_fac_ter);
                break;
            case 2: //Talumm
                await TalummHTTP.downloadPDF(this.state.invoice.num_fac_ter);
                break;
            case 3: //iFacturaApp
                await IFacturaAppHTTP.downloadPDFiFacturaApp(this.state.invoice.num_fac_ter);
                break;
        }
    }

    downloadPDF64Ftech = async (data) => {
        let factura = {
            prefijo: data.split("-")[0],
            folio: data.split("-")[1]
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/download-pdf-file`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(factura)
        }).then(res => res.blob()).then(blob => {
            const a = document.createElement('a');
            a.setAttribute('download', "documento-" + data + ".pdf");
            a.setAttribute('href', window.URL.createObjectURL(blob));
            a.click();
        }).catch(err => {
            console.log(err);
        });
    }

    calculateTotalCostServices(dataServices) {
        let costoTotal = 0;
        for (let i = 0; i < dataServices.length; i++) {
            costoTotal = costoTotal + parseFloat(dataServices[i].costo);
        }
        return costoTotal;
    }

    calculateTotalCostMedicines(dataMedicines) {
        let costoTotal = 0;
        if (dataMedicines != undefined) {
            for (let j = 0; j < dataMedicines.length; j++) {
                costoTotal = costoTotal + parseFloat(dataMedicines[j].costo_total);
            }
        }
        return costoTotal;
    }


    calculateTotalCost(dataServices, dataMedicines) {
        let costoServicios = this.calculateTotalCostServices(dataServices);
        let costoMedicamentos = this.calculateTotalCostMedicines(dataMedicines);
        let costoTotal = costoServicios + costoMedicamentos;
        return costoTotal;
    }

    previsualizeInvoice = async () => {
        let num_fac_ter = null;

        if (this.state.invoice != null) {
            if (this.state.invoice.num_fac_ter != null && this.state.invoice.num_fac_ter !== undefined) {
                num_fac_ter = this.state.invoice.num_fac_ter;
            }
        }

        let InvoiceUt = new InvoiceUtils();
        var idsReceipts = [this.props.location.state.dataCashReceipt.id_recibo];
        await InvoiceUt.getReceiptsById(idsReceipts, this.props.location.state.dataCashReceipt.id_tercero, num_fac_ter).then((res) => {
            if (res != null) {
                this.setState({ openModalPDF: true });
                InvoiceUt.generatePDFPrevisualization(res.factura, true);
            }
            else {
                console.log("Error consultando la Previsualizacion de la Factura");
            }
        }).catch((error) => {
            console.log(error);
            this.setState({ openModalPDF: false });
        });
    }

    alertModal = (type, message) => {
        this.setState({ showAlertModal: true, colorAlertModal: type, messagAlerteModal: message });
    }

    onOkModal = () => {
        if (this.state.colorAlertModal == "warning" && this.state.processInvalidCash == true && this.state.processCancel == false) {

            let clinicaData = JSON.parse(sessionStorage.getItem('clinica'));
            if (clinicaData != null && clinicaData != undefined) {
                if (clinicaData.recibos_cero == true) {
                    this.createReceipt();
                }
                else {
                    this.createInvalidReceipt();
                }
            }
            else {
                this.createReceipt();
            }
        }
        else if (this.state.colorAlertModal == "warning" && this.state.processInvalidCash == false && this.state.processCancel == true) {

            this.cancelReceipt();
        }
        else if (this.state.colorAlertModal == "warning" && this.state.processInvalidCash == false && this.state.processCancel == false) {
            this.createReceipt();
        }
        else if (this.state.colorAlertModal == "success" && this.state.dataCreated != null) {
            this.finishCreateCashReceipt(this.state.dataCreated);
        }
        else if (this.state.colorAlertModal == "success" && this.state.processCancel == true) {
            if (window.location.pathname === process.env.PUBLIC_URL + '/assitencial/receipt-admission') {
                history.replace(process.env.PUBLIC_URL + "/");
                setTimeout(() => {
                    history.replace({
                        pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                        state: {
                            dataPatient: this.props.location.state.dataPatient,
                            dataCashReceipt: null,
                            dataPlan: null,
                            dataProfile: null,
                            state: this.props.location.state.state
                        }
                    });
                }, 0);
            }
            else {
                history.push({
                    pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                    state: {
                        dataPatient: this.props.location.state.dataPatient,
                        dataCashReceipt: null,
                        dataPlan: null,
                        dataProfile: null,
                        state: this.props.location.state.state
                    }
                });
            }
        }

        this.setState({ showAlertModal: false, colorAlertModal: 'info', messagAlerteModal: '' });
    }

    processCancelReceipt = () => {
        this.setState({ showAlertModal: true, colorAlertModal: 'warning', messagAlerteModal: 'Esta completamente seguro(a) de anular este Recibo de Caja?', processCancel: true });
    }

    cancelReceipt = async () => {
        console.log("reciboCaja", this.props.location.state.dataCashReceipt);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/cancelar-recibo', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_recibo: this.props.location.state.dataCashReceipt.id_recibo, estado: true })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({ showAlertModal: true, colorAlertModal: 'success', messagAlerteModal: 'Recibo de Caja Anulado con Exito' });

        }).catch((e) => {
            this.setState({ showAlertModal: true, colorAlertModal: 'danger', messagAlerteModal: 'Ha ocurrido un error cancelando el Recibo de Caja, es posible que esta ya se halla Facturado' });
            console.log(e);
        });
    }

    validateMoneyReceipt = () => {
        /*
        if (!this.validate()) {
            this.setState({ processInvalidCash: false }, () => {
                this.setState({ showAlertModal: true, colorAlertModal: 'warning', messagAlerteModal: 'Esta Completamente seguro(a) de crear este Recibo de Caja?' });
            });
        }*/


        let money = this.state.cash;
        if (money == "" || money == null || money == undefined || money <= 0) {
            this.setState({ processInvalidCash: true }, () => {
                this.setState({ showAlertModal: true, colorAlertModal: 'warning', messagAlerteModal: 'El Valor del Recibo es 0, esta seguro que desea continuar?' });
            });
        }
        else {

            if (!this.validate()) {
                this.setState({ processInvalidCash: false }, () => {
                    this.setState({ showAlertModal: true, colorAlertModal: 'warning', messagAlerteModal: 'Esta Completamente seguro(a) de crear este Recibo de Caja?' });
                });
            }
        }
    }

    doOpenModalServiceUpdate = (opt, service) => {
        this.setState({
            serviceUpdateData: service
        }, () => {
            this.setState({ openModalServiceUpdate: opt });
        });
    }

    callbackReceiptAdmision = () => {
        this.loadDataCita();
        if (this.props.location.state.dataCashReceipt != null) {
            this.loadCashReceipt(this.props.location.state.dataCashReceipt).then((res) => {
                this.getInvoice(this.props.location.state.dataCashReceipt.id_recibo);

                this.setState({ reloadListReceipts: true }, () => {
                    this.setState({ reloadListReceipts: false });
                })
            });
        }
    }

    handlerDefineValue = (e) => {
        console.log({ estado: e.target.value })
        this.setState({ setValueBy: e.target.value })
    }

    handlerValueByPercentage = (value) => {
        let valueWholeReceipt = this.calculateTotalCost(this.state.services, this.state.medicines);
        let percentageValuePer = (valueWholeReceipt * value) / 100;
        let isNumInt = percentageValuePer % 1 === 0;
        let valueReceipt = 0;
        if (isNumInt) {
            valueReceipt = percentageValuePer;
        } else {
            let getDecimalValue = percentageValuePer.toString().split('.')[1];
            if (getDecimalValue > 4) {
                valueReceipt = Math.ceil(percentageValuePer);
            } else {
                valueReceipt = Math.floor(percentageValuePer);
            }
        }
        console.log({ value, valueWholeReceipt, percentageValuePer, valueReceipt })
        this.setState({ percentageValue: value, cash: valueReceipt })
    }

    render() {
        return (
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', margin: '0em 2em' }}>
                            {
                                this.props.location.state.pendingPatient != true ?
                                    <div>
                                        <Tooltip
                                            title="Regresar a la lista de admisiones"
                                            style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                        >
                                            <IconButton
                                                aria-label="upload picture"
                                                component="span"
                                                className='tooltip-top'
                                                onClick={() => {
                                                    history.push({
                                                        pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                                                        state: {
                                                            date: moment(this.props.location.state.datePrevious).format("YYYY-MM-DD"),
                                                            estado_form: this.props.location.state.dataPatient.estado_form,
                                                            indexPageF: this.props.location.state.indexPage
                                                        }
                                                    });
                                                }}
                                            >
                                                <ArrowBackIcon style={{ color: '#153365' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                    :
                                    <div>
                                        <Tooltip
                                            title="Regresar"
                                            style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                        >
                                            <IconButton
                                                aria-label="upload picture"
                                                component="span"
                                                className='tooltip-top'
                                                onClick={() => {
                                                    history.push({
                                                        pathname: process.env.PUBLIC_URL + '/management/patients-pending-invoice'
                                                    });
                                                }}
                                            >
                                                <ArrowBackIcon style={{ color: '#153365' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                            }
                            <div className="title-general-section-icon-arrow-back">
                                <h3>Crear recibo</h3>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Card>
                        <CardBody>

                            {this.state.dataPatient !== null ?
                                <div style={{ display: 'flex' }}>
                                    <div className="title-general">
                                        <h3>Admisión {this.state.dataPatient.id_admision}</h3>
                                    </div>
                                </div> : null}

                            <Row className='row-default-space-receipt'>
                                <Col >
                                    <Row>
                                        <div className='subtitle-general'>
                                            <h4 style={{ margin: '0.25em 0em' }}>Información del Paciente</h4>
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField
                                                key={`type-document`}
                                                name={`type-documen`}
                                                id="type-documen"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Tipo de Documento"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.typeDocument}
                                                onChange={(e) => { this.setState({ typeDocument: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <TextField
                                                key={`document-number`}
                                                name={`document-number`}
                                                id="document-number"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Número de Documento"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                placeholder={this.props.location.state.dataPatient.num_documento}
                                                value={this.state.documentNumber}
                                                onChange={(e) => { this.setState({ documentNumber: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField
                                                key={`names`}
                                                name={`names`}
                                                id="names"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Nombres"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                placeholder={this.props.location.state.dataPatient.fullname}
                                                value={this.state.names}
                                                onChange={(e) => { this.setState({ names: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField
                                                key={`correo`}
                                                name={`correo`}
                                                id="correo"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Correo"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.correo}
                                                onChange={(e) => { this.setState({ correo: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField
                                                key={`nroCelular`}
                                                name={`nroCelular`}
                                                id="nroCelular"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Celular"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                //placeholder={this.props.location.state.dataPatient.num_documento}
                                                value={this.state.cellphone}
                                                onChange={(e) => { this.setState({ cellphone: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField
                                                key={`direccion`}
                                                name={`direccion`}
                                                id="direccion"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Dirección"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                //placeholder={this.props.location.state.dataPatient.fullname}
                                                value={this.state.direccion}
                                                onChange={(e) => { this.setState({ direccion: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>

                                    </Row>
                                </Col>
                                <Col md={1}>
                                    <div className='flex-spac-ar-elem'>
                                        <hr className='vertical-hr' />
                                    </div>
                                </Col>
                                <Col>
                                    <Row>
                                        <div className='subtitle-general'>
                                            <h4 style={{ margin: '0.25em 0em' }}>Información del Cliente</h4>
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField
                                                key={`nombre_tercero`}
                                                name={`nombre_tercero`}
                                                id="type-documen"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Nombre"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.nombre_tercero}
                                                onChange={(e) => { this.setState({ nombre_tercero: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField
                                                key={`nit_tercero`}
                                                name={`nit_tercero`}
                                                id="type-documen"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="NIT"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.nit_tercero}
                                                onChange={(e) => { this.setState({ nit_tercero: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField
                                                key={`correo_tercero`}
                                                name={`correo_tercero`}
                                                id="type-documen"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Correo"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.correo_tercero}
                                                onChange={(e) => { this.setState({ correo_tercero: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField
                                                key={`telefono_tercero`}
                                                name={`telefono_tercero`}
                                                id="type-documen"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Teléfono"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.telefono_tercero}
                                                onChange={(e) => { this.setState({ telefono_tercero: e.target.value }) }}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField
                                                key={`direccion_tercero`}
                                                name={`direccion_tercero`}
                                                id="type-documen"
                                                style={{ width: '100%', margin: '0.5em 0em' }}
                                                label="Dirección"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                value={this.state.direccion_tercero != null ? this.state.direccion_tercero.direccion : null}
                                                onChange={(e) => { this.setState({ direccion_tercero: { direccion: e.target.value } }) }}
                                                disabled={true}
                                            />
                                        </Col>

                                    </Row>
                                </Col>

                                <Row className='row-default-space-receipt'>
                                    <Row>
                                        <div className='subtitle-general'>
                                            <h4 style={{ margin: '0.25em 0em' }}>Recibo</h4>
                                        </div>
                                    </Row>
                                    {!this.state.disabledFields &&
                                        <Row>
                                            <Col md={3}>
                                                <FormControl component="fieldset" style={{ display: 'flex', flexDirection: 'row', marginLeft: '0.5em' }}>
                                                    <RadioGroup
                                                        aria-label="rigth_patient"
                                                        name="radio-define-value"
                                                        value={this.state.setValueBy}
                                                        style={{ display: 'inline' }}
                                                        onChange={e => {
                                                            this.handlerDefineValue(e);
                                                        }}
                                                    >
                                                        <FormControlLabel value="PORCENTAJE" control={<Radio color="primary" disabled={this.state.disabledFields} />} label="Porcentaje" />
                                                        <FormControlLabel value="VALOR" control={<Radio color="primary" disabled={this.state.disabledFields} />} label="Valor" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col>
                                            {this.state.setValueBy === 'PORCENTAJE' &&
                                                <Col md={3}>
                                                    <TextField
                                                        label="Valor porcentaje"
                                                        name="transactionOtherNumber"
                                                        disabled={this.state.disabledFields}
                                                        value={this.state.percentageValue}
                                                        type="number"
                                                        onChange={(event) => {
                                                            this.handlerValueByPercentage(event.target.value);
                                                        }}
                                                        style={{ margin: 10, width: '100%' }}
                                                        className="medical-material-form__field"
                                                        InputLabelProps={{
                                                            style: { color: '#646777' },
                                                            shrink: true
                                                        }}
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                    }
                                    <Row>
                                        {this.state.type !== 4 ?                                            
                                            /* type: 1-Particular,2-Subsidiado,3-Contributivo, 4-Regimen Especial, 5-Contributivo Complementario, 6-SOAT */
                                            <>
                                                {this.state.type == 3 ?
                                                    <Col md={4}>
                                                        <TextField
                                                            select
                                                            label="Concepto"
                                                            name="concept"
                                                            value={this.state.concept}
                                                            disabled={this.state.disabledFields}
                                                            onChange={(event) => {
                                                                this.setState({ concept: event.target.value });
                                                            }}
                                                            style={{ margin: 10, width: '100%' }}
                                                            className="medical-material-form__field"
                                                            InputLabelProps={{
                                                                style: { color: '#646777' },
                                                                shrink: true
                                                            }}
                                                            required={true}
                                                            autoFocus
                                                            error={this.state.errors.hasOwnProperty("concept") ? this.state.errors.concept !== "" : false}
                                                            helperText={this.state.errors.concept}
                                                        >
                                                            {this.state.validateConsulta? null: <MenuItem key={1} value={'COPAGO'}>
                                                                COPAGO
                                                            </MenuItem>}
                                                            <MenuItem key={2} value={'CUOTA MODERADORA'}>
                                                                CUOTA MODERADORA
                                                            </MenuItem>
                                                        </TextField>
                                                    </Col>
                                                    : this.state.type == 2 ?
                                                        <Col md={4}>
                                                            <TextField
                                                                select
                                                                label="Concepto"
                                                                name="concept"
                                                                value={this.state.concept}
                                                                disabled={this.state.disabledFields}
                                                                onChange={(event) => {
                                                                    this.setState({ concept: event.target.value });
                                                                }}
                                                                style={{ margin: 10, width: '100%' }}
                                                                className="medical-material-form__field"
                                                                InputLabelProps={{
                                                                    style: { color: '#646777' },
                                                                    shrink: true
                                                                }}
                                                                required={true}
                                                                autoFocus
                                                                error={this.state.errors.hasOwnProperty("concept") ? this.state.errors.concept !== "" : false}
                                                                helperText={this.state.errors.concept}
                                                            >
                                                            {this.state.validateConsulta? null: <MenuItem key={1} value={'COPAGO'}>
                                                                COPAGO
                                                            </MenuItem>}
                                                                <MenuItem key={2} value={'CUOTA MODERADORA'}>
                                                                    CUOTA MODERADORA
                                                                </MenuItem>
                                                            </TextField>
                                                        </Col>
                                                        : this.state.type == 5 ?
                                                            <Col md={4}>
                                                                <TextField
                                                                    select
                                                                    label="Concepto"
                                                                    name="concept"
                                                                    value={this.state.concept}
                                                                    disabled={this.state.disabledFields}
                                                                    onChange={(event) => {
                                                                        this.setState({ concept: event.target.value });
                                                                    }}
                                                                    style={{ margin: 10, width: '100%' }}
                                                                    className="medical-material-form__field"
                                                                    InputLabelProps={{
                                                                        style: { color: '#646777' },
                                                                        shrink: true
                                                                    }}
                                                                    required={true}
                                                                    autoFocus
                                                                    error={this.state.errors.hasOwnProperty("concept") ? this.state.errors.concept !== "" : false}
                                                                    helperText={this.state.errors.concept}
                                                                >
                                                                {this.state.validateConsulta? null: <MenuItem key={1} value={'COPAGO'}>
                                                                    COPAGO
                                                                </MenuItem>}
                                                                    <MenuItem key={3} value={'CUOTA DE RECUPERACIÓN'}>
                                                                        CUOTA DE RECUPERACIÓN
                                                                    </MenuItem>
                                                                </TextField>
                                                            </Col>
                                                            : null}
                                            </>
                                            : this.state.type == 4 &&
                                            <Col md={4}>
                                                <TextField
                                                    select
                                                    label="Concepto"
                                                    name="concept"
                                                    value={this.state.concept}
                                                    disabled={this.state.disabledFields}
                                                    onChange={(event) => {
                                                        this.setState({ concept: event.target.value });
                                                    }}
                                                    style={{ margin: 10, width: '100%' }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' },
                                                        shrink: true
                                                    }}
                                                    required={true}
                                                    autoFocus
                                                    error={this.state.errors.hasOwnProperty("concept") ? this.state.errors.concept !== "" : false}
                                                    helperText={this.state.errors.concept}
                                                >
                                                    {this.state.validateConsulta? null: <MenuItem key={1} value={'COPAGO'}>
                                                        COPAGO
                                                    </MenuItem>}
                                                    <MenuItem key={2} value={'CUOTA MODERADORA'}>
                                                        CUOTA MODERADORA
                                                    </MenuItem>
                                                    <MenuItem key={3} value={'CUOTA DE RECUPERACIÓN'}>
                                                        CUOTA DE RECUPERACIÓN
                                                    </MenuItem>
                                                </TextField>
                                            </Col>
                                        }
                                        <Col md={4}>
                                            <TextField
                                                key={`Efectivo`}
                                                name={`Efectivo`}
                                                id="Efectivo"
                                                style={{ margin: 10, width: '100%' }}
                                                label="Valor"
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                type="number"
                                                placeholder=""
                                                disabled={this.state.type == 1 || this.state.type == 6 || this.state.disabledFields == true || this.state.setValueBy === 'PORCENTAJE' ? true : false}
                                                value={this.state.cash}
                                                onChange={(e) => { this.setState({ cash: e.target.value }) }}
                                                error={this.state.errors.hasOwnProperty("wayToPay") ? this.state.errors.wayToPay !== "" : false}
                                                helperText={this.state.errors.wayToPay}
                                            />
                                        </Col>

                                        <Col md={4}>
                                            <TextField
                                                select
                                                label="Medio de Pago"
                                                name="method"
                                                disabled={this.state.disabledFields}
                                                value={this.state.paymentType}
                                                onChange={(event) => {
                                                    this.setState({ paymentType: event.target.value });
                                                }}
                                                style={{ margin: 10, width: '100%' }}
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                                required={true}
                                                autoFocus
                                                error={this.state.errors.hasOwnProperty("paymentType") ? this.state.errors.paymentType !== "" : false}
                                                helperText={this.state.errors.paymentType}
                                            >
                                                <MenuItem key={1} value={'Efectivo'}>
                                                    Efectivo
                                                </MenuItem>
                                                <MenuItem key={2} value={'Tarjeta'}>
                                                    Tarjeta
                                                </MenuItem>
                                                <MenuItem key={3} value={'Otro'}>
                                                    Otro
                                                </MenuItem>
                                            </TextField>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {this.state.paymentType === "Otro" ?
                                            <Col md={4}>
                                                <TextField
                                                    label="Entidad"
                                                    name="nameEntity"
                                                    disabled={this.state.disabledFields}
                                                    value={this.state.nameEntity}
                                                    onChange={(event) => {
                                                        this.handlerNameEntity(event.target.value);
                                                    }}
                                                    style={{ margin: 10, width: '100%' }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' },
                                                        shrink: true
                                                    }}
                                                    autoFocus
                                                /* error={this.state.errors.hasOwnProperty("paymentType") ? this.state.errors.paymentType !== "" : false}
                                                helperText={this.state.errors.paymentType} */
                                                />
                                            </Col>
                                            : null}
                                        {this.state.nameEntity !== '' && this.state.paymentType === "Otro" ?
                                            <Col md={4}>
                                                <TextField
                                                    label="Nro. Transacción"
                                                    name="transactionOtherNumber"
                                                    disabled={this.state.disabledFields}
                                                    value={this.state.transactionOtherNumber}
                                                    type="number"
                                                    onChange={(event) => {
                                                        this.handlerNumberOtherTransaction(event.target.value);
                                                    }}
                                                    style={{ margin: 10, width: '100%' }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' },
                                                        shrink: true
                                                    }}
                                                    autoFocus
                                                /* error={this.state.errors.hasOwnProperty("paymentType") ? this.state.errors.paymentType !== "" : false}
                                                helperText={this.state.errors.paymentType} */
                                                />
                                            </Col>
                                            : null}
                                        {
                                            this.state.paymentType === "Tarjeta" ?
                                                <Col md={4}>
                                                    <TextField
                                                        select
                                                        label="Tipo de tarjeta"
                                                        name="cardType"
                                                        disabled={this.state.disabledFields}
                                                        value={this.state.typeCard}
                                                        onChange={(event) => {
                                                            //this.setState({ paymentType: event.target.value });
                                                            this.handlerCardType(event.target.value);
                                                        }}
                                                        style={{ margin: 10, width: '100%' }}
                                                        className="medical-material-form__field"
                                                        InputLabelProps={{
                                                            style: { color: '#646777' },
                                                            shrink: true
                                                        }}
                                                        required={true}
                                                        autoFocus
                                                        error={this.state.errors.hasOwnProperty("cardType") ? this.state.errors.cardType !== "" : false}
                                                        helperText={this.state.errors.cardType}
                                                    >
                                                        <MenuItem key={1} value={'Debito'}>
                                                            Débito
                                                        </MenuItem>
                                                        <MenuItem key={2} value={'Credito'}>
                                                            Crédito
                                                        </MenuItem>
                                                    </TextField>
                                                </Col>
                                                : null
                                        }
                                        {this.state.typeCard !== '' && this.state.paymentType === "Tarjeta" ?
                                            <Col md={4}>
                                                <TextField
                                                    label="Nro. Transacción"
                                                    name="transactionNumber"
                                                    disabled={this.state.disabledFields}
                                                    value={this.state.transactionNumber}
                                                    type="number"
                                                    onChange={(event) => {
                                                        this.handlerNumberTransaction(event.target.value);
                                                    }}
                                                    style={{ margin: 10, width: '100%' }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' },
                                                        shrink: true
                                                    }}
                                                    required={true}
                                                    autoFocus
                                                    error={this.state.errors.hasOwnProperty("transactionNumber") ? this.state.errors.transactionNumber !== "" : false}
                                                    helperText={this.state.errors.transactionNumber}
                                                />
                                            </Col>
                                            : null}
                                    </Row>

                                </Row>
                                <Row md={12} className='row-default-space-receipt'>
                                    <Row>
                                        <Col md={6} className='col-info-table-recipiets'>
                                            <Card outline>
                                                {
                                                    this.state.userPermits.includes(56) && this.state.invoice == null ? <>
                                                        {
                                                            this.state.services.length > 0 ?
                                                                <>
                                                                    <Row>
                                                                        <ReceiptAdmissionButtonUpdateFromPL
                                                                            services={this.state.services}
                                                                            idAdmision={this.state.dataPatient.id_admision}
                                                                            Callback={() => this.callbackReceiptAdmision()}
                                                                        />
                                                                    </Row>
                                                                </> : null
                                                        }
                                                    </>
                                                        : null
                                                }
                                                <h4 className='sub-title'>Información de los Servicios</h4>
                                                <table className="table table--bordered" >
                                                    <thead>
                                                        <tr>
                                                            <td >Servicio</td>
                                                            <td >CUPS</td>
                                                            <td >Costo</td>
                                                            {this.state.userPermits.includes(56) && this.state.invoice == null ? <td >Acción</td> : null}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.services.map((serData, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td><b>{serData.nombre}</b></td>
                                                                    <td>{serData.codigo}</td>
                                                                    <td>${formatNumber(serData.costo)}</td>
                                                                    {this.state.userPermits.includes(56) && this.state.invoice == null ? <>
                                                                        <td>
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                            <IconButton style={{ padding: 0 }} aria-label="upload picture" component="span"
                                                                                onClick={() => {
                                                                                    this.doOpenModalServiceUpdate(true, serData);
                                                                                }}>
                                                                                <EditOutlinedIcon />
                                                                            </IconButton>
                                                                        </td>
                                                                    </> : null}
                                                                </tr>
                                                            );
                                                        })}

                                                    </tbody>
                                                </table>
                                            </Card>
                                        </Col>
                                        <Col md={6} className='col-info-table-recipiets'>
                                            <Card outline>
                                                {
                                                    this.state.userPermits.includes(56) && this.state.invoice == null ?
                                                        <>
                                                            <Row>
                                                                <Tooltip title="Modificar precios de Medicamentos con base a la Lista de Precios Actual">
                                                                    <IconButton disabled={true} style={{ padding: 0 }} aria-label="upload picture" component="span"
                                                                        onClick={() => {

                                                                        }}>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Row>
                                                        </>
                                                        : null
                                                }
                                                <h4 className='sub-title'>Información de los Medicamentos</h4>
                                                <table className="table table--bordered" >
                                                    <thead>
                                                        <tr>
                                                            <td>Medicamento</td>
                                                            <td>Servicio donde es requerido</td>
                                                            <td className="text-center">Unidades</td>
                                                            <td className="text-center">Costo por Unidad</td>
                                                            <td className="text-center">Costo Total Medicamento</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.medicines.map((medic, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td><b>{medic.nom_articulo}</b></td>
                                                                    <td>{medic.nombre_servicio}</td>
                                                                    <td className="text-center">{medic.numero_unidades}</td>
                                                                    <td className="text-center">${formatNumber(medic.costo)}</td>
                                                                    <td className="text-center">${formatNumber(medic.costo_total)}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <hr></hr>
                                    <Row className='row-default-space-receipt'>
                                        <Row >
                                            <div className='subtitle-general'>
                                                <h4 style={{ margin: '0.25em 0em' }}>Detalle de Recibo</h4>
                                            </div>
                                        </Row>
                                        <Row style={{ marginTop: 20 }}>
                                            {
                                                this.state.type !== 1 && this.state.type !== 6 ?
                                                    <Col md={4}>
                                                        <h4 className='sub-title'>Concepto: {this.state.concept}</h4>
                                                    </Col> :
                                                    null
                                            }
                                            <Col md={4}>
                                                <h4 className='sub-title'>Valor: ${formatNumber(this.state.cash)}</h4>
                                            </Col>
                                            <Col md={4}>
                                                <h4 className='sub-title'>Medio de Pago: {this.state.paymentType}</h4>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 20 }}>
                                            <Col md={4}>
                                                <h4 className='sub-title'>Costo de Servicios: ${formatNumber(this.calculateTotalCostServices(this.state.services))}</h4>
                                            </Col>
                                            <Col md={4}>
                                                <h4 className='sub-title'>Costo de Medicamentos: ${formatNumber(this.calculateTotalCostMedicines(this.state.medicines))}</h4>
                                            </Col>
                                            <Col md={4}>
                                                <h4 className='sub-title'>Costo Total: ${formatNumber(this.calculateTotalCost(this.state.services, this.state.medicines))}</h4>
                                            </Col>
                                        </Row>
                                    </Row>

                                    <Row className='row-default-space-receipt'>
                                        <span className="form__form-group-error">{this.state.errors.hasOwnProperty("total") ? this.state.errors.total : ""}</span>
                                        <TextField
                                            key={`Total`}
                                            name={`Total`}
                                            id="total"
                                            style={{ margin: 10, width: '100%' }}
                                            label="Total"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' },
                                                shrink: true
                                            }}
                                            type="number"
                                            placeholder=""
                                            disabled={this.state.type == 1 || this.state.disabledFields == true ? true : false}
                                            value={parseInt(this.state.cash !== "" ? this.state.cash : "0") + parseInt(this.state.card !== "" ? this.state.card : "0") + parseInt(this.state.check !== "" ? this.state.check : "0")}
                                            onChange={(e) => { this.setState({ cash: e.target.value }) }}
                                        />
                                    </Row>

                                    <Row className='row-default-space-receipt'>
                                        <Col md={4}>
                                            {this.props.location.state.dataCashReceipt &&
                                                <div className="form">
                                                    <div className='subtitle-general'>
                                                        <h4 style={{ margin: '0.25em 0em' }}>Nota de Factura</h4>
                                                    </div>
                                                    <div className="form__form-group-field">
                                                        <textarea
                                                            disabled={this.state.invoice == null && this.props.location.state.dataCashReceipt != null && this.props.location.state.dataCashReceipt != undefined ? false : true}
                                                            id="textarea-receipt"
                                                            value={this.state.note}
                                                            name="textarea-receipt"
                                                            onChange={(e) => {
                                                                this.setState({ note: e.target.value });
                                                            }}
                                                        >
                                                        </textarea>
                                                    </div>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </Row>
                            </Row>
                            <Row className='row-default-space-receipt'>
                                {
                                    this.state.reloadListReceipts == false ? <>
                                        <ReceiptsAdmisions admision={this.props.location.state.dataPatient} />
                                    </> : <>
                                        <div className='text-center'>
                                            <Spinner animation="border" variant="success" />
                                        </div>
                                    </>
                                }

                                {this.props.location.state.dataCashReceipt == null ?
                                    <>
                                        {
                                            this.state.dataCreated == null ? <ButtonToolbar className="form__button-toolbar">
                                                <Button
                                                    disabled={this.calculateTotalCost(this.state.services, this.state.medicines) > 0 ? false : true}
                                                    color="primary"
                                                    onClick={() => {
                                                        this.validateMoneyReceipt();
                                                    }}
                                                >Confirmar Recibo
                                                </Button>
                                            </ButtonToolbar> : null
                                        }

                                    </>
                                    :
                                    <>
                                        <ButtonToolbar className="form__button-toolbar">
                                            {this.props.location.state.dataCashReceipt.valido == true ?
                                                <>
                                                    <Button
                                                        //disabled={this.state.electronicInvoiceLoading}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            this.showPDF();
                                                        }}
                                                    >Ver Recibo de Caja</Button>
                                                </>
                                                : null}
                                            {
                                                this.state.userPermits.includes(40) ?
                                                    <Button
                                                        //disabled={this.state.electronicInvoiceLoading}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            this.processCancelReceipt();
                                                        }}
                                                    >Anular Recibo de Caja
                                                    </Button>
                                                    : null
                                            }
                                            &nbsp;&nbsp;
                                            {this.state.userPermits.includes(16) ?
                                                <>
                                                    <Button
                                                        //disabled={this.state.electronicInvoiceLoading}
                                                        color="primary"
                                                        onClick={() => {
                                                            this.previsualizeInvoice();
                                                        }}>
                                                        Previsualizar Factura
                                                    </Button>
                                                    {
                                                        this.state.invoice == null ?
                                                            <Button
                                                                disabled={this.state.electronicInvoiceLoading}
                                                                color="primary"
                                                                onClick={() => {
                                                                    this.generateInvoice();
                                                                }}>
                                                                Generar Factura
                                                            </Button>

                                                            :
                                                            this.state.invoice.cufe != null || this.state.cufe != null ?
                                                                <Button
                                                                    disabled={this.state.electronicInvoiceLoading}
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        console.log("CARGANDO PDF");
                                                                        this.setState({ electronicInvoiceLoading: true });
                                                                        this.downloadPDFDIAN().then(() => {
                                                                            this.setState({ electronicInvoiceLoading: false });
                                                                        }).catch(() => {
                                                                            this.setState({ electronicInvoiceLoading: false });
                                                                        });
                                                                    }}>
                                                                    Descargar Factura PDF
                                                                </Button> :
                                                                <Button
                                                                    disabled={this.state.electronicInvoiceLoading}
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        this.againAtttemptElectronicInvoice(this.props.location.state.dataCashReceipt, this.state.invoice.id_factura_t, this.state.invoice.num_fac_ter);
                                                                    }}>
                                                                    Transmitir Facturación Electronica
                                                                </Button>
                                                    }
                                                </> : null}
                                        </ButtonToolbar>
                                        {this.state.electronicInvoiceLoading ? (<Spinner animation="border" variant="success" />) : null}
                                    </>
                                }
                            </Row>
                        </CardBody>
                    </Card>
                </Row>

                <AlertModal
                    color={this.state.colorAlertModal}
                    title={this.state.messagAlerteModal}
                    modal={this.state.showAlertModal}
                    onOk={() => {
                        this.onOkModal();
                    }}
                    toggle={() => {
                        if (this.state.dataCreated != null && this.state.colorAlertModal == 'success') {
                            this.finishCreateCashReceipt(this.state.dataCreated);
                        }
                        else {
                            this.setState({ showAlertModal: false, colorAlertModal: 'info', messagAlerteModal: '', processCancel: true, processInvalidCash: false, dataCreated: null })
                        }
                    }
                    }
                />

                <ModalTemplatePdf openModal={this.state.openModalPDF} closeModal={() => this.setState({ openModalPDF: false })} />

                {
                    this.state.userPermits.includes(56) && this.state.invoice == null && this.state.openModalServiceUpdate == true ? <>
                        <ModalUpdatePricesAdmision
                            service={this.state.serviceUpdateData}
                            idAdmision={this.state.dataPatient.id_admision}
                            opened={this.state.openModalServiceUpdate}
                            closeModal={() => {
                                this.doOpenModalServiceUpdate(false, null);
                            }}
                            callbackReceiptAdmision={() => this.callbackReceiptAdmision()}
                        />
                    </> : null
                }

            </Container>);
    }
}

export default ReceiptAdmission;
